export function isJacoRunning() {
    return !!window["JacoRecorder"];
}

export function isJacoRecording() {
    const isRecording = isJacoRunning() && window["JacoRecorder"].state && window["JacoRecorder"].state.isRecording;

    return isRecording;
}

export function startJacoRecorder() {
    if (isJacoRunning() && !isJacoRecording()) {
        return window["JacoRecorder"].startRecording();
    }
}

export function stopJacoRecorder() {
    if (isJacoRunning() && isJacoRecording()) {
        return window["JacoRecorder"].stopRecording();
    }
}

export function setRecordingStatus(record) {
    return record ? startJacoRecorder() : stopJacoRecorder();
}
